import { useState, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid, Button, Typography, CircularProgress } from '@mui/material';

import * as HrActions from '../../../../store/actions/hr.action';
import { getHrState } from '../../../../store/selector/hr.selector';
import DownloadModal from '../../ui/modal/download-modal';
import { IDownloadModal } from '../../../interfaces/modal.interface';

const DashboardSignatory = () => {
  /* eslint-disable camelcase */
  const dispatch = useDispatch();

  const {
    is_loading_dashboard_list,
    reports_query,
    dashboard_list: {
      ApplicationsReport: {
        SignatoryBreakdown: { breakdown },
      },
    },
  } = useSelector(getHrState);

  const [modalOptions, setModalOptions] = useState<IDownloadModal>({
    open: false,
    heading: 'Applications List',
    query: '',
  });

  const searchSignatoryParams = (sig: string, stat: string) => {
    const q = { ...reports_query, signatory: sig, status: stat };

    if (q) {
      dispatch(HrActions.DashboardApprovalData(q));
    }
  };

  const toggleModal: (e?: string) => void = (e) => {
    setModalOptions((p) => ({
      ...p,
      open: !p.open,
      query: e || '',
    }));
  };

  return (
    <Box sx={{ background: '#fff', height: '70vh', width: '100%', overflowY: 'auto', p: '2rem' }}>
      {is_loading_dashboard_list && breakdown.length === 0 ? (
        <Grid
          item
          xs={12}
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress color='primary' size={40} thickness={5} />

          <Typography sx={{ mt: '1rem' }}>Loading Signatory List</Typography>
        </Grid>
      ) : (
        <Grid container sx={{ display: 'flex', alignItems: 'center' }}>
          <Grid item xs={8} sx={{ mb: '2rem' }}>
            <Typography color='primary' sx={{ fontWeight: 'bold' }}>
              Signatory Email
            </Typography>
          </Grid>

          <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', mb: '2rem' }}>
            <Typography color='primary' sx={{ fontWeight: 'bold' }}>
              Approved
            </Typography>
          </Grid>

          <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', mb: '2rem' }}>
            <Typography color='primary' sx={{ fontWeight: 'bold' }}>
              Pending
            </Typography>
          </Grid>

          {breakdown.map(
            (list: { signatory: string; approved: number; pending: number }, i: number) => {
              return (
                <Fragment key={i}>
                  <Grid item xs={8} sx={{ mt: i !== 0 ? '1rem' : 0 }}>
                    <Typography>{list.signatory}</Typography>
                  </Grid>

                  <Grid
                    item
                    xs={2}
                    sx={{ display: 'flex', justifyContent: 'center', mt: i !== 0 ? '1rem' : 0 }}
                  >
                    <Button
                      onClick={() => {
                        toggleModal(list.signatory);
                        searchSignatoryParams(list.signatory, 'approved');
                      }}
                      variant='text'
                      color='primary'
                      sx={{ fontWeight: 'bold' }}
                    >
                      {list.approved}
                    </Button>
                  </Grid>

                  <Grid
                    item
                    xs={2}
                    sx={{ display: 'flex', justifyContent: 'center', mt: i !== 0 ? '1rem' : 0 }}
                  >
                    <Button
                      onClick={() => {
                        toggleModal('approvals');
                        searchSignatoryParams(list.signatory, 'created');
                      }}
                      variant='text'
                      color='primary'
                      sx={{ fontWeight: 'bold' }}
                    >
                      {list.pending}
                    </Button>
                  </Grid>
                </Fragment>
              );
            },
          )}
          <DownloadModal onClose={toggleModal} options={modalOptions} />
        </Grid>
      )}
    </Box>
  );
};

export default DashboardSignatory;
